import { render } from "./DeepPerformanceTotalFunction.vue?vue&type=template&id=e2478aa8&scoped=true&ts=true"
import script from "./DeepPerformanceTotalFunction.vue?vue&type=script&lang=ts"
export * from "./DeepPerformanceTotalFunction.vue?vue&type=script&lang=ts"

import "./DeepPerformanceTotalFunction.vue?vue&type=style&index=0&id=e2478aa8&scoped=true&lang=css"
import "./DeepPerformanceTotalFunction.vue?vue&type=style&index=1&id=e2478aa8&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2478aa8"]])

export default __exports__